import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ViewController, NavController } from 'ionic-angular';
import { SocialSharing } from '@ionic-native/social-sharing';
import { LoadingController } from 'ionic-angular';
import { Platform } from 'ionic-angular';
import { BrowserTab } from '@ionic-native/browser-tab';
import { AlertController } from 'ionic-angular';
import { AboutPage } from '../../pages/about/about';
import { BrComService } from '../../service/BrComService';
import { BrComDao } from '../../service/BrComDao';
import { TipoLayout } from '../../shared/interfaces';
import { FotoProvider } from '../../providers/foto/foto';
import { LoginWebPage } from '../../pages/login-web/login-web'

@Component({
  selector: 'menu-geral',
  templateUrl: 'menu-geral.html'
})
export class MenuGeralComponent {

  @Input() content: any;
  @Input() empresa: any;
  @Output() changeLayout: EventEmitter<string>;
  @Output() userLogout: EventEmitter<boolean>;
  public abrirMenuLayout: boolean;
  public nomeApp: any = "?";
  public nomeLayouts: string[];

  constructor(public viewCtrl: ViewController, private browserTab: BrowserTab, public navCtrl: NavController, 
    private socialSharing: SocialSharing, private loadingCtrl: LoadingController, public platform: Platform,
     private alertController: AlertController, private brComService: BrComService,
    private brComDao: BrComDao, private fotoProvider: FotoProvider) {
      this.nomeLayouts = this.getLayouts();
      this.userLogout = new EventEmitter<boolean>();
      this.changeLayout = new EventEmitter<string>();
      this.abrirMenuLayout = false;
      /*this.appVersion.getAppName().then((val) => {
        this.nomeApp = String(val).toLowerCase();
      });*/
  }

  private close(): void {
    this.viewCtrl.dismiss();
  }

  private removerAutenticacao(): void {
    this.userLogout.emit(false);
  }

  public get nomeUsuario(): string {
    if (this.empresa) {
      return this.empresa.NomeUsuario;
    }
    return '';
  }

  public reiniciar(): void {
    const alerta = this.alertController.create({
      title: "AVISO",
      message: "Você tem certeza que deseja sair?",
      buttons: [{
        text: "Cancelar",
        role: "cancel"
      },{
        text: "Confirmar",
        handler:  () => {
          this.brComService.limpar();
          this.navCtrl.setRoot(LoginWebPage);
          this.navCtrl.popToRoot();
          this.removerAutenticacao();
        }
      }]
    });
    alerta.present();
  }

  public sobre(): void {
    let rec = this.empresa;
    this.navCtrl.push(AboutPage, { dados: { codUsuario: rec.CodUsuario, codEmpresa: rec.CodEmpresa, nomeUsuario: rec.NomeUsuario } }); 
  }

private getUrlAppAndroid(): string {
  const nomeApp = this.nomeApp;
  let urlSite = "https://play.google.com/store/apps/details?id=br.infobr.brcomunique.mobile.";
  if (nomeApp != "brcomunique") {
    if (nomeApp == "sindprevssc") {
      urlSite = urlSite + nomeApp + "3";
    } else if (nomeApp == "sinpofesc") {
      urlSite = urlSite + nomeApp + "2";
    } else if (nomeApp == "applider") {
      urlSite = urlSite + "lideranca";
    } else if (nomeApp == "ansef-mg"){
      urlSite = urlSite + "ansefmg";
    } else {
      urlSite =  urlSite + nomeApp;
    }
  }
  return urlSite;
} 
  
private getUrlAppIos(): string {
    let stId: string
    const nomeApp = this.nomeApp;
    switch (nomeApp){
      case "aprasc":
        stId = "1297579290";
        break;
      case "sindprevssc":
        stId = "1376671593";
        break;
      case "fenapef":
        stId = "1308383313";  
        break;
      case "sindisprevrs":
        stId = "1317867979";
        break;
      case "sinpofesc":
        stId = "1373352667";
        break;
      case "applider":
        stId = "1458135123";
        break;
      case "ansef-mg":
        stId = "1458899639";
        break;
      default:
        stId = "1265084122";//BrComunique
        break;
    }
    
    return "https://itunes.apple.com/us/app/" + nomeApp + "/id" + stId + "?l=pt&ls=1&mt=8";
  }

  public async compartilhar(): Promise<void> {
    const load = this.loadingCtrl.create({content: "Aguarde ..."});
    load.present();
    const mensagem = `Baixe o App Android: ${this.getUrlAppAndroid()} Baixe o App iOS: ${this.getUrlAppIos()}`;
    await this.socialSharing.share(mensagem);
    load.dismiss();
  }

  public atualizar(): void{
    let url: string;
    if(this.platform.is("ios")) {
      url = this.getUrlAppIos();
    } else {
      url = this.getUrlAppAndroid();
    }

    this.browserTab.openUrl(url);
  }

  public toggleMenuLayout(): void {
    this.abrirMenuLayout = !this.abrirMenuLayout;
  }

  public trocarLayout(layout: string): void {
    this.changeLayout.emit(layout);
    this.brComDao.gravarLayoutPreferencial(TipoLayout[layout.toUpperCase()], this.empresa.CodEmpresa);
  }

  public getLayouts(): string[] {
    let layouts = [];
    for (const key in TipoLayout) {
      let isValueProperty = parseInt(key, 10) >= 0
      if (!isValueProperty) {
        let valor = key.toLowerCase();
        valor = valor[0].toUpperCase() + valor.slice(1);
        layouts.push(valor);
      }
    }
    return layouts
  }

  public fecharMenuLayout(): void {
    this.abrirMenuLayout = false;
  }

  public isLayoutUtilizado(layout: string): boolean {
    const layoutPreferencial = this.brComDao.recuperarLayoutPreferencial(this.empresa.CodEmpresa);
    return layoutPreferencial === Number(TipoLayout[layout.toUpperCase()]);
  }

  public getImagemUsuario():string{
    if (this.empresa) {
      const hashImagem = this.empresa.HashImagem;
      if (hashImagem !== "") 
        return this.fotoProvider.getUrlImagemServidor(hashImagem);
      else 
        return 'assets/img/usuario.png';
    } else {
      return 'assets/img/usuario.png';
    }
  
  }


}



// WEBPACK FOOTER //
// ./src/components/menu-geral/menu-geral.ts